import { getViewNameFromOrderAlertType } from '../../../services/order-alerts-service';
import { getViewNameFromOrderStatus, ALL_SEARCH_RESULTS_ORDER_STATUS } from '../../../services/sales-order-service';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
import { AlertType } from '../../../enums/alert-type';

import * as Actions from './orders.nav.actions';
import { ALL_ORDERS_PAGE_VIEWS } from '../../../pages/orders-page/orders-page-view-constants';

const initialState = {
  searchData: {
    searchTerm: '',
  },
};

const transformOrderStatusCountsByStore = (counts) =>
  counts.reduce((statusMap, status) => {
    const { storeGuid, count, orderGridStatus, statusCode, orderAlertType } = status;
    // TODO: At the api level, quicksearch results come back with 'statusCode' rather than 'orderGridStatus' which comes from the normal orders request.
    //       We should change one of the endpoints to match the other. To fix for now, I'm changing `OrdersApi.getSearchTermCountShipmentMode` to map statusCode to orderGridStatus.
    const name = getViewNameFromOrderStatus(orderGridStatus || statusCode);
    if (name && name !== 'unknown') {
      const key = `${name}-${storeGuid}`;
      const ASRkey = `${getViewNameFromOrderStatus(ALL_SEARCH_RESULTS_ORDER_STATUS)}-${storeGuid}`;
      const allResultsCountByStore = statusMap[ASRkey] || 0;

      return {
        ...statusMap,
        [key]: count,
        [ASRkey]: allResultsCountByStore + count,
      };
    }
    if (orderAlertType) {
      const alertKeys = getViewNameFromOrderAlertType(orderAlertType);
      const updatedStatusObject = {};
      alertKeys?.forEach((alertKey) => {
        updatedStatusObject[alertKey] = count;
      });
      return {
        ...statusMap,
        ...updatedStatusObject,
      };
    }

    return statusMap;
  }, {});

const addTopLevelCounts = (statusMap) => {
  const topLevelStatusMap = {};
  ALL_ORDERS_PAGE_VIEWS.forEach((view) => {
    const viewKeys = Object.keys(statusMap).filter((s) => s.startsWith(view.id));
    const count = viewKeys.reduce((sum, key) => sum + statusMap[key], 0);
    topLevelStatusMap[view.id] = count;
  });

  return {
    ...statusMap,
    ...topLevelStatusMap,
  };
};

const actionHandlerMap = {
  [Actions.ORDERS_CHANGE_VIEW_SEARCH]: (state, { searchData }) => {
    return {
      ...state,
      statusCountMap: {},
      searchData: searchData || state.searchData,
    };
  },
  [Actions.ORDERS_GET_COUNTS_SUCCESS]: (state, { counts = [] }) => {
    if (!counts) {
      return state;
    }
    const orderAlertsCountObj = counts.find((count) => count.orderAlertType === AlertType.GLOBAL);
    const orderAlertsCount = orderAlertsCountObj ? orderAlertsCountObj.count : 0;
    const statusCountMap = addTopLevelCounts(transformOrderStatusCountsByStore(counts));
    return {
      ...state,
      statusCountMap,
      orderAlertsCount,
    };
  },
  [Actions.CLEAR_SEARCH_INPUT]: (state) => {
    return {
      ...state,
      searchData: Object.assign({}, state.searchData, { searchTerm: '' }),
      selected: false,
    };
  },
  [Actions.SEARCH_TERM_CHANGE]: (state, action) => {
    return {
      ...state,
      searchData: Object.assign({}, state.searchData, {
        searchTerm: action.searchValue,
      }),
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './orders.nav.reducer.metadata';
